export const getLadderPosition = (data, teamProviderId) => {
    let position;

    data.forEach((item) => {
        if (item.team.providerId === teamProviderId) {
            position = item.position;
        }
    });

    return position;
};
